import React, { useEffect, useState } from "react";

export const FRAGMENT_ICON_NAMES = ["notice-circle"] as const;
export type FragmentIconName = (typeof FRAGMENT_ICON_NAMES)[number];

// The icon type used by Skapa
type Icon = (prefix?: string) => React.SVGProps<SVGElement>[];

const iconLoaders: Record<FragmentIconName, () => Promise<{ default: Icon }>> =
  {
    "notice-circle": () =>
      import("@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/NoticeCircleIconPath"),
  };

/**
 * This loads an icon asynchronously.
 */
export function useFragmentIcon(name: FragmentIconName): Icon {
  const [icon, setIcon] = useState<Icon>(() => () => []);

  useEffect(() => {
    iconLoaders[name]().then((mod) => {
      setIcon(() => mod.default);
    });
  }, [name]);

  return icon;
}
